<script setup>
import { computed } from 'vue';

const props = defineProps({
  /**
   * Conteúdo da célula a ser exibido
   */
  content: {
    type: [String, Number],
    default: '',
  },
  /**
   * Número máximo de caracteres antes de truncar (incluindo espaços)
   */
  maxLength: {
    type: Number,
    default: 60,
  },
  /**
   * Número máximo de linhas a exibir
   */
  maxLines: {
    type: Number,
    default: 2,
  },
  /**
   * Exibir tooltip com conteúdo completo ao passar o mouse
   */
  showTooltip: {
    type: Boolean,
    default: true,
  }
});

const formattedContent = computed(() => {
  if (!props.content) return '';
  const content = String(props.content);
  return content.length > props.maxLength 
    ? content.slice(0, props.maxLength) + '...' 
    : content;
});

const tooltipContent = computed(() => {
  return props.showTooltip && props.content ? String(props.content) : '';
});
</script>

<template>
  <div 
    class="truncated-cell"
    :class="{ 'has-tooltip': showTooltip && content && content.length > maxLength }"
    :title="tooltipContent"
  >
    <span>{{ formattedContent }}</span>
  </div>
</template>

<style scoped>
.truncated-cell {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: v-bind('maxLines');
  overflow: hidden;
  word-break: break-word;
  text-overflow: ellipsis;
  max-width: 100%;
}

.has-tooltip {
  cursor: help;
}
</style>